import { urls } from '@repo/app-constants';
import { Markdown, Typography } from 'components';
import useGetKitIdParam from 'hooks/useGetKitIdParam';
import { useMemo } from 'react';
import useMicrobiomeAge from 'services/microbiome/useMicrobiomeAge';
import Factor from './Factor';
import styles from './FactorsSection.module.css';
import groupMicrobiomeAge from './utils/groupMicrobiomeAgeResponse';

export default function FactorsSection() {
  const kitId = useGetKitIdParam();
  const { data } = useMicrobiomeAge(kitId ?? '');
  const groupedData = useMemo(() => groupMicrobiomeAge(data ?? []), [data]);

  return (
    <div className={styles.sectionContainer}>
      <Typography variant='heading-m'>Factors impacting your score</Typography>
      <Typography variant='body-s' color='dark'>
        <Markdown>
          {`Unlike your actual birthday, your Microbiome Age can go down. You can “turn back the clock” by eating foods that support beneficial bacteria and avoiding things that help pro-inflammatory bacteria grow [\\[1\\]](${urls.MICROBIOME_AGE_REFERENCE_URL}). Refer to your Action Plan for a prioritized list of steps to support these metrics and your overall gut health.`}
        </Markdown>
      </Typography>
      <div className={styles.factorsContainer}>
        {groupedData.map(f => (
          <Factor key={f.section?.id} factor={f} />
        ))}
      </div>
    </div>
  );
}
